import { apiClient } from '../../api/client';

import { getTrackingApiBaseUrl } from '../../config/env';

export interface LoginFunnelProvider {
  provider: string;
  click_actions: number;
  unique_installs: number;
  new_users: number;
  existing_users: number;
  success_new_users: number;
  success_existing_users: number;
}

export interface LoginFunnelMetrics {
  n1: number;
  providers: LoginFunnelProvider[];
  new_user?: Record<string, number>;
  active_user?: Record<string, number>;
}

export interface DailyMetrics {
  date: string;
  metrics: Record<string, unknown>;
}

export async function getDailyMetrics(from: string, to: string, signal?: AbortSignal): Promise<DailyMetrics[]> {
  const response = await apiClient.get<{ data: DailyMetrics[] }>('/api/v1/metrics/stats', {
    baseURL: getTrackingApiBaseUrl(), params: { from, to }, signal, timeout: 30000, withCredentials: false,
  });
  return response.data.data;
}
